<script lang="ts">
	import { getContext } from "svelte";
	import type { TLocaleGroup } from "@xbs/lib-kanban";

	export const locale = getContext<any>("wx-i18n");
	export const _: TLocaleGroup = locale.getGroup("kanban");

</script>
